export default __webpack_public_path__ + "static/media/3.832cf87c.jpg";